import React from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import { Helmet } from '@dr.pogodin/react-helmet';

const Favicon = ({ fields }) => {
  const image_16x16 = getFieldValue(fields, 'image_16x16');
  const image_32x32 = getFieldValue(fields, 'image_32x32');

  const stripCdnHost = (url) => {
    try {
      const parsed = new URL(url);
      return parsed.pathname + parsed.search;
    } catch {
      return url;
    }
  };

  return (
    <Helmet>
      <link
        rel='icon'
        type='image/png'
        href={stripCdnHost(image_32x32.src)}
        sizes='32x32'
      />
      <link
        rel='icon'
        type='image/png'
        href={stripCdnHost(image_16x16.src)}
        sizes='16x16'
      />
    </Helmet>
  );
};

export default Favicon;
